import { Modules, RouteConstants } from "@valenzinsights/data";
import { LibraryDocumentViewer } from "@valenzinsights/library-module";
import { Error401, Error404 } from "@valenzinsights/shared-pages";

import { Login } from "./Login";

export const LoginRoutes = [
	{
		path: "/",
		element: <Login />,
	},
	{
		path: RouteConstants.ErrorUnauthorized,
		element: <Error401 />,
	},
	{
		path: RouteConstants.LibraryDocumentView,
		element: <LibraryDocumentViewer />,
		module: Modules.Library,
	},
	{
		path: "*",
		element: <Error404 />,
	},
];
